const STORAGE_KEY = 'fateh_form_submissions'
const MAX_PER_WINDOW = 3
const WINDOW_MS = 15 * 60 * 1000
const COOLDOWN_MS = 60 * 1000

function getHistory() {
  try {
    return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '[]')
  } catch {
    return []
  }
}

export function checkRateLimit() {
  try {
    const now = Date.now()
    const history = getHistory()
    const windowStart = now - WINDOW_MS
    const recent = history.filter((t) => t > windowStart)

    if (recent.length >= MAX_PER_WINDOW) {
      const retryMinutes = Math.ceil((recent[0] + WINDOW_MS - now) / 1000 / 60)
      return {
        allowed: false,
        reason: 'window',
        retryAfter: retryMinutes,
        message: `Too many requests. Please try again in ${retryMinutes} minute${retryMinutes !== 1 ? 's' : ''}, or call us directly.`,
      }
    }

    if (recent.length > 0) {
      const elapsed = now - recent[recent.length - 1]
      if (elapsed < COOLDOWN_MS) {
        const retrySecs = Math.ceil((COOLDOWN_MS - elapsed) / 1000)
        return {
          allowed: false,
          reason: 'cooldown',
          retryAfter: retrySecs,
          message: `Please wait ${retrySecs} second${retrySecs !== 1 ? 's' : ''} before submitting again.`,
        }
      }
    }

    return { allowed: true }
  } catch {
    return { allowed: true }
  }
}

export function recordSubmission() {
  try {
    const now = Date.now()
    const history = getHistory()
    const windowStart = now - WINDOW_MS
    const recent = history.filter((t) => t > windowStart)
    recent.push(now)
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(recent))
  } catch {
    // fail silently — sessionStorage may be unavailable
  }
}
